import { createAction, createReducer } from "@reduxjs/toolkit";
import { api } from "./helpers/api";
import { LOADING_INITIAL_STATE, setRequested, setReceived, setFailed } from "modules/loader-watchers/helpers/loading";

export const requestedExperiences = createAction("experiences/requested");
export const receivedExperiences = createAction("experiences/received");
export const failedExperiences = createAction("experiences/failed");
export const cleanedExperiences = createAction("experiences/cleaned");
export const requestedExperiencesByGuide = createAction("experiences/byGuide/requested");
export const receivedExperiencesByGuide = createAction("experiences/byGuide/received");
export const failedExperiencesByGuide = createAction("experiences/byGuide/failed");
export const cleanExperiencesByGuide = createAction("experiences/byGuide/clean");
export const requestedExperienceById = createAction("experiences/byId/requested");
export const receivedExperienceById = createAction("experiences/byId/received");
export const failedExperienceById = createAction("experiences/byId/failed");

const initialState = {
  ...LOADING_INITIAL_STATE,
  list: [],
  byGuide: {
    loading: false,
    error: null,
    data: [],
    metaData: {}
  },
  experienceById: {
    loading: false,
    error: null,
    experienceDetail: {}
  }
};

const experiencesReducer = createReducer(initialState, {
  [requestedExperiences]: (state) => setRequested(state),
  [receivedExperiences]: (state, action) => {
    setReceived(state);
    state.list = action.payload;
  },
  [failedExperiences]: (state) => setFailed(state),
  [cleanedExperiences]: () => initialState,
  [requestedExperiencesByGuide]: (state) => {
    state.byGuide.loading = true;
    state.byGuide.error = null;
  },
  [receivedExperiencesByGuide]: (state, action) => {
    state.byGuide.loading = false;
    const newData = action.payload.data;
    state.byGuide.data = [...state.byGuide.data, ...newData]
    state.byGuide.metaData = action.payload.metadata
  },
  [failedExperiencesByGuide]: (state, action) => {
    state.byGuide.loading = false;
    state.byGuide.error = action.payload;
  },
  [cleanExperiencesByGuide]: (state) => {
    state.byGuide.error = {};
    state.byGuide.data = [];
    state.byGuide.metaData = {};
  },
  [requestedExperienceById]: (state) => {
    state.experienceById.loading = true;
    state.experienceById.error = null;
  },
  [receivedExperienceById]: (state, action) => {
    state.experienceById.loading = false;
    state.experienceById.experienceDetail = action.payload.data;
  },
  [failedExperienceById]: (state, action) => {
    state.experienceById.loading = false;
    state.experienceById.error = action.payload;
  },
});

export default experiencesReducer;

export const fetchExperiences = () =>
  api({
    url: "/guide/trips/embedded_experiences_list",
    onStart: requestedExperiences.type,
    onSuccess: receivedExperiences.type,
    onError: failedExperiences.type,
  });

export const fetchExperiencesByGuide = (uuid, page = 1, append = false) =>
  api({
    url: `/embedded_experiences?guuid=${uuid}&page=${page}`,
    onStart: requestedExperiencesByGuide.type,
    onSuccess: receivedExperiencesByGuide.type,
    onError: failedExperiencesByGuide.type,
  });

export const fetchExperienceById = (id) =>
  api({
    url: `/embedded_experiences/${id}`,
    onStart: requestedExperienceById.type,
    onSuccess: receivedExperienceById.type,
    onError: failedExperienceById.type,
  });
